import React from 'react';
import './App.css';
import { Fade, Slide, slide } from "react-awesome-reveal";


function ImagenConTitulo(props) {
  return (
    <div className="imagen-con-titulo">
      <img src={props.imagenUrl} alt={props.titulo} />
      <h2 className="titulo-catalogue">
        <a href={props.pdfUrl} download={props.pdfFileName}>
          {props.titulo}
        </a>
      </h2>
    </div>
  );
}

function Catalogue() {
  const catalogItems = [
    {
      imagenUrl: "img/Catalogue/cata--01.jpg",
      pdfUrl: "img/Catalogue/SuperRugby2025.pdf",
      pdfFileName: "SuperRugby2025.pdf",
      titulo: "Download Catalogue"
    },
    {
      imagenUrl: "img/Catalogue/cata--02.jpg",
      pdfUrl: "img/Catalogue/SilverFerns.pdf",
      pdfFileName: "SilverFerns.pdf",
      titulo: "Download Catalogue"
    },
    {
      imagenUrl: "img/Catalogue/cata--03.jpg",
      pdfUrl: "img/Catalogue/NZRL.pdf",
      pdfFileName: "NZRL.pdf",
      titulo: "Download Catalogue"
    },
    {
      imagenUrl: "img/Catalogue/cata--04.jpg",
      pdfUrl: "img/Catalogue/NRL2025.pdf",
      pdfFileName: "NRL2025.pdf",
      titulo: "Download Catalogue"
    },
    {
      imagenUrl: "img/Catalogue/cata--05.jpg",
      pdfUrl: "img/Catalogue/AllBlacks2025.pdf",
      pdfFileName: "AllBlacks2025.pdf",
      titulo: "Download Catalogue"
    },
    {
      imagenUrl: "img/Catalogue/cata--06.jpg",
      pdfUrl: "img/Catalogue/A-League24-25.pdf",
      pdfFileName: "A-League24-25.pdf",
      titulo: "Download Catalogue"
    },
    {
      imagenUrl: "img/Catalogue/fff.png",
      pdfUrl: "img/Catalogue/Catalogue 2023_V2.pdf",
      pdfFileName: "Ford-Football-Ferns.pdf",
      titulo: "Download Catalogue"
    }
  ];

  return (
    <section className="Catalogue" id="catalogue">
      <Fade triggerOnce cascade delay={300} >
      <h1>SEKEM CATALOGUES</h1> 
      
      <h4 className='white'>Discover Our Latest Catalogues for Sekem and Ford Football Ferns</h4>
      <p>Download our catalogues and view the latest collections of licensed sports merchandise, Sports gear, supporters’ apparel and accessories. Whether you are an avid Sports fan, a dedicated athlete or sports enthusiast, our catalogues provide an in-depth look into the exceptional products we have to offer, that embody the spirit of sportsmanship and excellence.</p> 
      <div className="imagenes-contenedor">
        {catalogItems.map((item, index) => (
          <ImagenConTitulo
            key={index}
            imagenUrl={item.imagenUrl}
            pdfUrl={item.pdfUrl}
            pdfFileName={item.pdfFileName}
            titulo={item.titulo}
          />
        ))}
      </div>
      </Fade>
    </section>
  );
}

export default Catalogue;
